import { distanceKm, type Country } from './countries';
import { distLevel, levelEmoji } from './clue';

const LABEL: Record<string, string> = { classic: 'Classic', flag: 'Flag', outline: 'Outline' };
const ORDER = ['classic', 'flag', 'outline'];

/** Wordle 式文本战绩(不限次数 → N/∞;保留结果方块) */
export function buildShareText(
  mode: string,
  num: number,
  guesses: Country[],
  answer: Country,
  streak: number,
): string {
  const grid = guesses
    .map((g) => (g.cca3 === answer.cca3 ? '🟩' : levelEmoji(distLevel(distanceKm(g, answer)))))
    .join('');
  return `GeoDle ${LABEL[mode] ?? mode} #${num} ${guesses.length}/∞\n${grid}\nStreak ${streak} · geodle.org`;
}

/** Unlimited 文本战绩(含 Streak / Best) */
export function buildUnlimitedText(
  mode: string,
  guesses: Country[],
  answer: Country,
  streak: number,
  best: number,
): string {
  const grid = guesses
    .map((g) => (g.cca3 === answer.cca3 ? '🟩' : levelEmoji(distLevel(distanceKm(g, answer)))))
    .join('');
  return `GeoDle ${LABEL[mode] ?? mode} Unlimited\n${grid}\nSolved in ${guesses.length} · Streak ${streak} · Best ${best}\ngeodle.org`;
}

/** 把一局结果编码成紧凑串(供 OG 端点解码上色):命中=g,其余按距离档 o/y/b/k */
export function encodeGrid(guesses: Country[], answer: Country): string {
  return guesses
    .map((g) => {
      if (g.cca3 === answer.cca3) return 'g';
      const l = distLevel(distanceKm(g, answer));
      return l === 'hot' ? 'o' : l === 'warm' ? 'y' : l === 'cool' ? 'b' : 'k';
    })
    .join('');
}

/** 今日整体战报文本(不剧透:只显示各模式是否完成) */
export function buildReportText(num: number, solved: string[], streak: number): string {
  const marks = ORDER.map((m) => `${LABEL[m]} ${solved.includes(m) ? '✓' : '·'}`).join('  ');
  // 战报只统计三个核心模式(Connections / Draw 同 Connections 先例,不计入)
  const n = solved.filter((m) => ORDER.includes(m)).length;
  return `GeoDle #${num} — ${n}/${ORDER.length}\n${marks}\nStreak ${streak} · geodle.org`;
}

/** 各模式完成位串(classic/flag/outline → "110") */
export function encodeModes(solved: string[]): string {
  return ORDER.map((m) => (solved.includes(m) ? '1' : '0')).join('');
}

// Connections 分享:每行=一次提交的 4 格,按各国真实所属组的难度色上色(结束后才已知,不泄露)。
const CONN_EMOJI = ['', '🟨', '🟩', '🟦', '🟪']; // tier 1..4
export function buildConnectionsText(
  num: number,
  submissions: string[][], // picks(cca3)
  tierOf: (cca3: string) => number,
  won: boolean,
): string {
  const grid = submissions.map((row) => row.map((c) => CONN_EMOJI[tierOf(c)] || '⬜').join('')).join('\n');
  return `GeoDle Connections #${num}\n${grid}\n${won ? 'Solved' : 'X'} · geodle.org`;
}
